import type { ComponentType } from 'react'

type Predicate<TArgs> = (args: TArgs) => boolean

export type VariantComponentMap<TComponent extends {}, TVariant extends string> = Partial<
  Record<TVariant, ComponentType<TComponent> | undefined>
> & {
  default: ComponentType<TComponent>
}

export type VariantPredicateList<TVariant extends string, TArgs> = [TVariant, Predicate<TArgs>][]

export const useVariants = <TComponent extends {}, TArgs>(
  variants: VariantPredicateList<string, TArgs>,
  map: VariantComponentMap<TComponent, string>,
  args: TArgs
): ComponentType<TComponent> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeVariant] = variants.filter(([_, predicate]) => predicate(args)).map(([variant]) => variant)

  return map[activeVariant] ?? map.default ?? null
}
